module.exports = __webpack_public_path__ + "065faaf607fac0ccefafddbf63793c50.svg";